import "core-js/stable";
import React from 'react';
import ReactDOM from 'react-dom';
import { Router } from 'react-router-dom';
import BroadcastChannel from 'broadcast-channel';
import { createBrowserHistory } from 'history';
import { Provider } from 'mobx-react';
import { syncHistoryWithStore } from 'mobx-react-router';
import { when } from 'mobx';

import '@sogei/react-web-components-catalog/dist/css/uikit.css';
import '@sogei/react-web-components-catalog/dist/css/uikit/agenzia-entrate.css';
import 'Css/app.css';

import { Spinner, AuthMenu, AuthHeader, AuthFooter, Messages } from './containers/layout.jsx';
import RootStore from './stores';
import { PATH_INIT } from './config/portale-config';
import AppRouter from "./components/commons/router.jsx";
import './assets/i18n';
import { ROUTE_ERROR } from "./assets/frontendRouting.js";
import { isFromError, isFromFermo, isFromProfilazione } from "./assets/utils/queryParams.js";

const rootStore = new RootStore();
const browserHistory = createBrowserHistory();
const history = syncHistoryWithStore(browserHistory, rootStore.routingStore);

const channel = new BroadcastChannel('portale-agenzia-entrate');

class App extends React.Component {
  constructor(props) {
    super(props);
    this.state = { init: false, forwardRoute: true };
    this.disposeWhen = null;
  }

  componentDidMount() {
    // Sync tra tab
    channel.onmessage = (path) => {
      rootStore.refreshStore();
      this.setState({ forwardRoute: false });
      rootStore.routingStore.push(path);
    };

    // PATH_INIT → poi attendi che userInfo sia popolato (da AuthHeader) e procedi
    rootStore.service.doAjax('GET', PATH_INIT)
      .then(() => {
        this.disposeWhen = when(
          () => !!rootStore.userInfoStore.userInfo.codiceFiscale,   // attende che AuthHeader popoli userInfo
          () => {
            const path = history.location.pathname;

            if (isFromProfilazione(path) || isFromError(path) || isFromFermo(path)) {
              this.setState({ init: true });
              return;
            }

            rootStore.qualificheStore.fetchQualifiche(path, (response) => {
              if (!response.success) {
                rootStore.routingStore.push(process.env.CONTEXT_PATH + ROUTE_ERROR);
              }
              this.setState({ init: true });
            });
          }
        );
      })
      .catch(() => {
        rootStore.routingStore.push(process.env.CONTEXT_PATH + ROUTE_ERROR);
        this.setState({ init: true });
      });

    // Notifica tra tab
    this.unsubscribeFromStore = (history.listen || history.subscribe)((location, action) => {
      if (this.state.forwardRoute) {
        channel.postMessage(location.pathname);
        rootStore.uiStore.clearMessages();
      } else {
        this.setState({ forwardRoute: true });
      }
    });
  }

  componentWillUnmount() {
    this.unsubscribeFromStore && this.unsubscribeFromStore();
    this.disposeWhen && this.disposeWhen(); // cleanup del when
    channel.close();
  }

  render() {
    return (
      <>
        {/* Render SEMPRE l’header così può popolare userInfo */}
        <AuthHeader />

        {this.state.init ? (
          <>
            <AuthMenu />
            <Messages className="container-fluid py-3 py-md-4" />
            <main role="main" className="main-min-vh" id="main">
              <AppRouter />
            </main>
          </>
        ) : (
          // Spinner in attesa di init
          <main role="main" className="main-min-vh d-flex align-items-center justify-content-center" id="main">
            <Spinner />
          </main>
        )}

        <AuthFooter />
      </>
    );
  }
}

ReactDOM.render((
  <Router history={history}>
    <Provider rootStore={rootStore}><App /></Provider>
  </Router>
), document.getElementById('root'));
